import type { GenericQA } from '@/models/generic.model';

export const everythingYouNeedToKnow: GenericQA[] = [
  {
    question: 'Is this a one-time purchase?',
    answer: [
      'Yes! This is a one-time purchase. There are no subscription fees. This test is to help you understand your body more.',
    ],
  },
  {
    question: 'What is the cost for the full platform?',
    answer: [
      'If you decide to move forward with your personalized health and fitness plan compatible with the Alter System, which includes the app, genetic nutrition plan, biometric wearable, 1:1 personal coach, and an optional workout screen, the full cost ranges from $2,495 for Alter Anywhere, to $2,995 for Alter One.  We offer many financing options starting around $83/month.',
    ],
  },
  {
    question: 'Can I use my data from other DNA tests?',
    answer: [
      'Unfortunately we cannot use any DNA test results from a 3rd party. Our DNA report is specifically designed with robust data security measures to safeguard your genetic information, and focuses on unique fitness, and nutrition biomarkers. These key areas allow us to create a fully personalized program for you, guided by a complimentary session with a fitness advisor who will help you turn your results into actionable steps to achieve your health goals.',
    ],
  },
  {
    question: 'Privacy guaranteed',
    answer: [
      'Your DNA privacy is our utmost priority. We employ rigorous security measures to ensure your data remains confidential and protected throughout your journey with Alter. We use robust data security measures to safeguard your genetic information. Your DNA sample and genetic information are secure with Alter and our CLIA-certified, CAP-accredited Laboratory Partner.',
      'The results of your DNA test are stored in a secured database. Your DNA sample is automatically destroyed after testing and quality control checks. You can also ask us to delete your data from our systems anytime.',
    ],
  },
  {
    question: 'What is your DNA test guarantee?',
    answer: [
      'If your personalized DNA results don’t provide a personalized path to you achieving your weight loss, or health goals, we’ll refund your money—no commitment, no risk.',
    ],
  },
  {
    question: 'Shipping & returns',
    answer: [
      'We cover the costs of shipping both ways. A prepaid label and packaging is included with your DNA test.',
    ],
  },
  {
    question: 'What’s in the box?',
    answer: [
      'Medical grade DNA swab',
      'Free return shipping envelope to send back your DNA sample',
      'Comprehensive DNA report',
      'Complimentary consultation with an Alter Fitness Advisor to walk you through your results.',
    ],
    bullets: true,
  },
];
